import { BasketPriceModel } from './BasketPriceModel';

export class BasketAddonModel {
    public code: string;
    public isRecommended: boolean;
    public price: BasketPriceModel;
    public name?: string;
}